import React from 'react';
import createClass from 'create-react-class';
import { withTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from 'arbitrip-common/translation/const';

// const blacklist = [
//   /Missing property description/i
// ];

function isDescriptionValid(desc) {
    if (typeof desc !== 'string') {
        return false;
    }

    var trimmed = desc.trim();

    if (trimmed.length === 0) {
        return false;
    }

    // if (blacklist.some(function(regex) {return regex.test(trimmed)})) {
    if (trimmed.indexOf('Missing property description.') >= 0) {
        return false;
    }

    return true;
}

function capitalizeFirstLetter(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}

function reformatTitle(title) {
    return title.split('_').map(capitalizeFirstLetter).join(' ');
}

/*
amenities
dining
business_amenities
rooms
attractions
location
headline
renovations
national_ratings
*/

const TITLE_KEYS = {
    amenities: 'HotelInfoTitles.Amenities',
    dining: 'HotelInfoTitles.Dining',
    business_amenities: 'HotelInfoTitles.BusinessAmenities',
    rooms: 'HotelInfoTitles.Rooms',
    attractions: 'HotelInfoTitles.Attractions',
    location: 'HotelInfoTitles.Location',
    renovations: 'HotelInfoTitles.Renovations',
    national_ratings: 'HotelInfoTitles.NationalRatings',
};

function renderTitle(title, t, forceOriginalTitles) {
    if (title && typeof title === 'string') {
        const key = title.toLowerCase();
        if (forceOriginalTitles) {
            // When showing original content, titles should be shown in English
            return '<strong>' + reformatTitle(title) + ':</strong>';
        }
        const i18nKey = TITLE_KEYS[key];
        const label = i18nKey ? t(i18nKey, { defaultValue: reformatTitle(title) }) : reformatTitle(title);
        return '<strong>' + label + ':</strong>';
    }

    return null;
}

function renderDescriptionWithTitle(description, t, forceOriginalTitles) {
    if (description && description.constructor === Object) {
        if (description.headline) {
            description.location = description.headline + '.<br>' + description.location;
            delete description.headline;
        }
        return Object.entries(description).map(([title, content]) => (
            <p
                key={title}
                dangerouslySetInnerHTML={{ __html: renderTitle(title, t, forceOriginalTitles) + ' ' + content }}
            />
        ));
    }

    return description;
}

var AboutComponent = createClass({
    displayName: 'AboutComponent',

    render: function () {
        const { t } = this.props;
        const forceOriginalTitles = !!this.props.forceOriginalTitles;
        var description = renderDescriptionWithTitle(this.props.description, t, forceOriginalTitles);

        if (!isDescriptionValid(description)) {
            description = renderDescriptionWithTitle(description, t, forceOriginalTitles);
            if (!description) {
                return null;
            }
        }

        return (
            <div className="about">
                <div className="title">
                    <span>{forceOriginalTitles ? t('About', { lng: SUPPORTED_LANGUAGES.EN }) : t('About')}</span>
                    <span> </span>
                    <span>{this.props.hotel_name}</span>
                </div>
                <div className="description">{description}</div>
            </div>
        );
    },
});

export default withTranslation()(AboutComponent);
